import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "invisible-utf-character"
}
const _hoisted_2 = ["textContent"]

import {computed} from "vue";


const __default__ = {
    name: "InvisibleCharactersHighlight"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    text: {}
  },
  setup(__props: any) {

let props = __props;

let splitText = computed(() => {
    let text: string = "";
    if (typeof props.text == "string") {
        text = props.text;
    } else if (typeof props.text == "object") {
        text = JSON.stringify(props.text, null, 2);
    } else if (typeof props.text != "undefined" && props.text !== null) {
        text = text.toString();
    } else {
        text = "";
    }
    return text.split(/[\u0000-\u0009\u000B-\u001F\u007F-\u009F\u200B-\u200F\u202A-\u202E\u2060-\u2069\uFEFF]/g);
})

//const modifiedText = text.replace(/[\u200B-\u200F\u2060-\u2064\uFEFF]/g, '·');
//console.log(modifiedText); // Пример·текста·с·нулевой·шириной

return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(splitText), (part, index) => {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
      (index > 0)
        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_1, [...(_cache[0] || (_cache[0] = [
            _createTextVNode("·", -1)
          ]))])), [
            [_directive_my_tooltip, 'Текст содержит невидимый символ']
          ])
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        textContent: _toDisplayString(part)
      }, null, 8, _hoisted_2)
    ], 64))
  }), 256))
}
}

})